module.exports = __webpack_public_path__ + "img/bn.e546bc2a.jpg";